import React, { useEffect, useContext, useState } from 'react'
import { API } from 'api/API';
import { PAYMENTINTENT_TOKEN_URL } from 'config/config';
import { extractError } from 'api/ErrorUtil';
import { CheckoutContext } from '../CheckoutContext';


const OfflinePayment = ({ paymentFunction, formData }) => {

    const { paymentDispatch, paymentData } = useContext(CheckoutContext)

    const submitOfflinePayment = async () => {

        const commitmentItems = formData.paymentCartItems.map(paymentCartItem => ({
            commitmentId: paymentCartItem.id,
            accountNumber: paymentCartItem?.account?.number,
            accountType: paymentCartItem?.accountType?.accountType,
            commitmentType: paymentCartItem.commitmentType,
            commitmentPaymentAmount: paymentCartItem.itemDetail.amountDue,
            paymentItems: paymentCartItem.itemDetail.lineItems,
            committmentFrequency: paymentCartItem.itemDetail.frequency
        }));

        try {
            let paymentUpdateResp = await API.post(PAYMENTINTENT_TOKEN_URL, {
                payer: formData.payer,
                commitmentItems: commitmentItems,
                customerConsentsToPayPfFees: formData.customerConsentsToPayPfFees,
                paymentSourceType: formData.paymentSourceType,
                paymentCorrespodence: formData.paymentCorrespodence,
                receiptInCompanyName: formData.receiptInCompanyName
            });
            paymentDispatch({ type: 'PAYMENT_PENDING_APPROVAL', payload: {paymentResponse: paymentUpdateResp.data} });
        } catch (error) {
            let errors = extractError(error);
            paymentDispatch({ type: 'PAYMENT_ERROR', payload: { errors: errors } });
            return
        }
    }
    useEffect(() => {
        paymentFunction.current = submitOfflinePayment;
    }, [submitOfflinePayment, paymentData, formData])

    return
}

export default OfflinePayment